import { ElementType, useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { StepProps } from 'components/cardswap/types';
import Dialog from 'components/dialog';
import ConfirmDialog from 'components/form/ConfirmDialog';
import { laptopAndAbove } from 'style/mediaQuery';

import { CardSwapFlow } from '../Flow';
import { useCardSwapContext } from '../useCardSwapContext';

const FullSize = styled.div`
  height: 100%;
  @media ${laptopAndAbove} {
    height: calc(100vh - 8 * var(--unit));
  }
`;

const DialogBody = styled(Vertical)`
  padding: var(--double-unit);
  text-align: center;
`;

const DialogTitle = styled.p`
  font: var(--t-24);
  font-weight: var(--t-bold);
`;

const DialogSubtitle = styled.p`
  font: var(--t-16);
  color: var(--c-neutral-600);
`;

type Props = {
  open: boolean;
  cancelTrade: () => Promise<void>;
  completeTrade: StepProps['completeTrade'];
  onClose: StepProps['onClose'];
  steps: ElementType<StepProps>[];
  useCardTradeItem?: boolean;
};

export const CardSwapDialog = ({
  open,
  steps,
  completeTrade,
  cancelTrade,
  onClose,
  useCardTradeItem,
}: Props) => {
  const [confirmDialog, setConfirmDialog] = useState(false);
  const { formatMessage } = useIntl();
  const { clearCardSwapState } = useCardSwapContext();
  const confirm = async () => {
    setConfirmDialog(false);
    await cancelTrade();
    clearCardSwapState();
  };
  return (
    <Dialog open={open} fullWidth maxWidth={false}>
      <>
        <ConfirmDialog
          open={confirmDialog}
          onConfirm={() => {
            confirm();
          }}
          onClose={() => {
            setConfirmDialog(false);
          }}
          message={
            <DialogBody>
              <DialogTitle>
                {formatMessage({
                  id: 'CardSwapDialog.cancelDialog.title2',
                  defaultMessage: 'Are you sure you want to cancel?',
                })}
              </DialogTitle>
              <DialogSubtitle>
                {formatMessage({
                  id: 'CardSwapDialog.cancelDialog.message3',
                  defaultMessage:
                    'Your next available Card Swap will be available in 24 hours',
                })}
              </DialogSubtitle>
            </DialogBody>
          }
          cancelCta={formatMessage({
            id: 'CardSwapDialog.cancelDialog.cancelCta',
            defaultMessage: 'Go back',
          })}
          cta={formatMessage({
            id: 'CardSwapDialog.cancelDialog.confirmCta2',
            defaultMessage: 'Yes, cancel',
          })}
        />
        <FullSize>
          <CardSwapFlow
            steps={steps}
            setOnCloseConfirmDialog={setConfirmDialog}
            cancelTrade={cancelTrade}
            completeTrade={completeTrade}
            onClose={onClose}
            useCardTradeItem={useCardTradeItem}
          />
        </FullSize>
      </>
    </Dialog>
  );
};
